"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.case1 = void 0;
exports.case1 = {
    id: 10,
    case_uid: "ee4a399c-5532-4452-8f91-d6595f686c48",
    caseRuns: [
        {
            version: "2.0",
            case_json_id: 10,
            case_id: 10,
            case_status: "active",
            process_instance_id: 10,
            process_instance_guid: "67bbd9fd-7b1b-489b-a3df-5371055362b0",
            case_encounter_id: 4,
            encounter_uid: "6b61d79d-6263-419b-bb81-002944397950",
            process_uid: "b0ba3449-6a68-45bb-8d68-952d0303aabc",
            case_uid: "ee4a399c-5532-4452-8f91-d6595f686c48",
            caserun_uid: "67bbd9fd-7b1b-489b-a3df-5371055362b0",
            date_of_service: "2023-02-06",
            datetime_of_service: "2023-02-06 09:46:57 EST",
            external_id: "148874375",
            process_status: null,
            run_type: null,
            primary_process_indicator: null,
            source_type: null,
            service_line: "Inpatient Professional Coding",
            tenant_code: "HFHS",
            tenant_name: "Henry Ford Health System",
            tenant_timezone: "America/New_York",
            health_system_code: "HFHS",
            patient_name: "JASMINE SILKMOTH",
            date_of_birth: "1953-02-12",
            patient_gender: "male",
            patient_identifier: {
                number: null,
                issuer: null,
                type: null
            },
            visit_number: {
                number: "10737996807",
                issuer: null,
                type: null
            },
            account_number: {
                number: "10740653901",
                issuer: null,
                type: null
            },
            patient_class: "OUTPATIENT",
            patient_type: "11",
            reason_for_visit: null,
            primary_insurance: null,
            primary_insurance_category: null,
            interaction_uid: "9e824617-9dc3-4b95-b294-388825abab63",
            "external_interaction_uid ": "fa53f2fd-a5ae-5cee-8a69-7b56abfb126c",
            encounter_identifier: {
                number: null,
                issuer: null,
                type: null
            },
            point_of_care: null,
            place_of_service: null,
            billing_location: null,
            billing_provider_specialty: null,
            billing_provider_name: null,
            billing_provider_number: {
                number: null,
                issuer: "EPIC",
                type: "IDNO"
            },
            scheduling_department: null,
            scheduling_department_code: null,
            attending_provider_specialty: "Ophthalmology",
            attending_provider_name: "KUMAR, NITIN",
            attending_provider_number: {
                number: null,
                issuer: "EPIC",
                type: "IDNO"
            },
            referring_provider_specialty: "Internal Medicine",
            referring_provider_name: "PIERSKALLA, RONALD J",
            referring_provider_number: {
                number: null,
                issuer: "EPIC",
                type: "IDNO"
            },
            rendering_provider_specialty: null,
            rendering_provider_name: null,
            rendering_provider_number: {
                number: null,
                issuer: null,
                type: null
            },
            admission_datetime: null,
            discharge_datetime: null,
            performing_provider_specialty: null,
            performing_provider_name: null,
            performing_provider_number: {
                number: null,
                issuer: null,
                type: null
            },
            service_provider_specialty: null,
            service_provider_name: null,
            service_provider_number: {
                number: null,
                issuer: null,
                type: null
            },
            child_case_list: [
                {
                    type: "primary",
                    case_id: 299270,
                    case_uid: "f73553e9-16c8-47ce-9c28-495cbb818b25",
                    caserun_uid: "41673236-f4ef-473a-92ad-2e6e98c13ee2"
                },
                {
                    case_id: 299677,
                    case_uid: "c11f3503-82ca-42d3-a8fa-6678e02b3864",
                    caserun_uid: "75ae27f6-9fc6-4c2e-ba7b-24555351cada"
                }
            ],
            hl7_insurance_plan_id: "102003003",
            hl7_insurance_plan_text: "MEDICARE PLUS BLUE ADV",
            hl7_insurance_payer_id: "102003",
            hl7_insurance_payer_name: null,
            hl7_insurance_plan_type: null,
            tenant_insurance_plan_id: null,
            tenant_insurance_plan_text: null,
            tenant_insurance_payer_id: null,
            tenant_insurance_payer_number: null,
            tenant_insurance_payer_name: null,
            tenant_medicare_contractor: null,
            medicare_contractor: null,
            medicare_jurisdiction: null,
            patient_primary_facility: null,
            service: null,
            transaction_id: null,
            mappings: [
                {
                    name: null,
                    value: null,
                    mapped_values: [
                        {
                            name: null,
                            value: null,
                            values: []
                        }
                    ]
                }
            ],
            notes: [
                {
                    document_id: "1",
                    id: null,
                    description: null,
                    content: "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",
                    filename: null,
                    encoding: "base64",
                    mime_type: "text/plain",
                    type: "PN"
                }
            ],
            send_to_coder_datetime: null,
            case_completed_datetime: null,
            automated_indicator: null,
            automation_eligible: null,
            message_datetime: "2023-02-06 09:46:57 EST",
            message_code: "MDM",
            message_trigger_event: "T08",
            observation_id: null,
            observation_text: null,
            observation_subid: null,
            ssn_number: "020-11-2222",
            hospital_service: null,
            admitting_provider_name: null,
            admitting_provider: {
                number: null,
                issuer: "EPIC",
                type: "IDNO"
            },
            admission_type: null,
            alternate_visit_number: "763890444",
            hospital_account_record: "763890444",
            note_final_sign_provider: null,
            note_specialty_designation: null,
            attending_provider: {
                number: null,
                issuer: "EPIC",
                type: "IDNO"
            },
            consulting_provider_name: null,
            consulting_provider: {
                number: null,
                issuer: "EPIC",
                type: "IDNO"
            },
            discharge_disposition: null,
            observation_status: null,
            assigned_document_auth_number: null,
            assigned_document_auth_name: null,
            entity_id: null,
            placer_order_number_id: null,
            placer_order_number_namespace_id: null,
            document_completion_status: "AU",
            document_confidentiality_status: null,
            document_availability_status: "AV",
            document_type: "PN",
            authentication_person_datetime: null,
            authentication_person_name: null,
            authentication_person: {
                number: null,
                issuer: "EPIC",
                type: null
            },
            document_content_presentation: "text",
            activity_datetime: "2023-02-06 09:20:00 EST",
            primary_activity_provider_number: null,
            primary_activity_provider_name: null,
            origination_datetime: "2023-02-06 09:45:51 EST",
            edit_datetime: "2023-02-06 09:46:36 EST",
            originator_number: null,
            originator_name: "KUMAR, NITIN",
            phase: null,
            environment: null,
            invoices: [
                {
                    guid: "48b8af6f-6ac3-41de-b723-aa71c500bfb6",
                    type: "CLINICAL",
                    health_plan_id: null,
                    patient_type: "11",
                    billing_location: null,
                    billing_area: null,
                    division: null,
                    facility: null,
                    date_of_service: "2023-02-06",
                    datetime_of_service: "2023-02-06 09:46:57 EST",
                    filler_number: {
                        number: null,
                        issuer: null,
                        type: null
                    },
                    billing_provider_name: null,
                    billing_provider_number: {
                        number: null,
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    ordering_provider_name: null,
                    ordering_provider_number: {
                        number: null,
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    referring_provider_name: null,
                    referring_provider_number: {
                        number: null,
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    performing_provider_name: null,
                    performing_provider_number: {
                        number: null,
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    custom_values: {
                        customKey: null
                    }
                },
                {
                    guid: "604e3534-9ca2-4c62-86c7-0fac79efe1ea",
                    type: "ASSEMBLED",
                    health_plan_id: null,
                    patient_type: "11",
                    billing_location: null,
                    billing_area: null,
                    division: null,
                    facility: null,
                    date_of_service: "2023-02-06",
                    datetime_of_service: "2023-02-06 09:46:57 EST",
                    filler_number: {
                        number: null,
                        issuer: null,
                        type: null
                    },
                    billing_provider_name: null,
                    billing_provider_number: {
                        number: null,
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    ordering_provider_name: null,
                    ordering_provider_number: {
                        number: null,
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    referring_provider_name: null,
                    referring_provider_number: {
                        number: null,
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    performing_provider_name: null,
                    performing_provider_number: {
                        number: null,
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    custom_values: {
                        customKey: null
                    },
                    transactions: [
                        {
                            guid: "dd393a3b-630a-41d1-86a4-e91b4f5780fd",
                            department_code: null
                        }
                    ]
                }
            ],
            specialty: null,
            send_to_coder_orchestrator: null,
            coder_orchestrator_destination: null,
            feedback_loop_enabled: null,
            last_entity_update: null
        }
    ]
};
//# sourceMappingURL=case1.js.map